import { bl_fi_my_einvoice_from_irb_event_RowClass } from '../../dbschema/bl_fi_my_einvoice_from_irb_event.model';
import { BaseContainerModel } from '../base-container.model';

export class FromIRBEventContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_from_irb_event: bl_fi_my_einvoice_from_irb_event_RowClass = new bl_fi_my_einvoice_from_irb_event_RowClass();
}
